import { render } from "./GenerateStudentCode.vue?vue&type=template&id=a12ff9d0&scoped=true"
import script from "./GenerateStudentCode.vue?vue&type=script&lang=js"
export * from "./GenerateStudentCode.vue?vue&type=script&lang=js"

import "./GenerateStudentCode.vue?vue&type=style&index=0&id=a12ff9d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a12ff9d0"]])

export default __exports__